import clsx from 'clsx'
import { FC, useEffect, useMemo, useRef, useState } from 'react'
import 'swiper/css'
import { A11y, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { CategoryItem, CategoryItemProps } from '@/features/catalog/categories-grid/ui/category-item/category-item'

import { TSection } from '@/shared/types/deprecated-types'
import { Icon } from '@/shared/ui/icon'

import { CategoriesGridLoader } from './categories-grid-loader/categories-grid-loader'

import cls from './categories-grid.module.scss'

export type CategoriesGridProps = {
	items: CategoryItemProps[]
	currentSection?: TSection
	className?: string
	isLoading?: boolean
}

type OtherLinksConfigTypes = {
	acs?: {
		code: string
		imgSrc: string
	}
	comp?: {
		code: string
		imgSrc: string
	}
}

// const SWIPER_BREAKPOINTS = {
// 	Xs: 1,
// 	Sm: 1,
// 	Md: 1,
// 	Lg: 4,
// 	Xl: 6
// }

export const CategoriesGrid: FC<CategoriesGridProps> = ({ currentSection, items, className, isLoading }) => {
	const [otherLinks, setOtherLinks] = useState<OtherLinksConfigTypes>(null)
	const filteredItems = useMemo(() => items.filter(item => item.COUNT !== `0` && !item.UF_DONT_SHOW_IN_LIST), [items])
	const navigationNextRef = useRef(null)
	const navigationPrevRef = useRef(null)

	useEffect(() => {
		if (!currentSection) return

		const otherLinksConfig: OtherLinksConfigTypes = {}

		if (currentSection.UF_ACCESSORIES_LINK) {
			otherLinksConfig.acs = {
				code: currentSection.UF_ACCESSORIES_LINK,
				imgSrc: currentSection.UF_ACCESSORIES_PICTURE
			}
		}

		setOtherLinks(otherLinksConfig)
	}, [currentSection])

	if (isLoading) {
		return (
			<section className={clsx(cls.root, className)}>
				<CategoriesGridLoader />
			</section>
		)
	}

	return (
		<section className={clsx(cls.root, className)}>
			<Swiper
				slidesPerView={'auto'}
				spaceBetween={8}
				grabCursor
				modules={[A11y, Navigation]}
				navigation={{
					prevEl: navigationPrevRef?.current,
					nextEl: navigationNextRef?.current
				}}>
				{filteredItems.map(item => (
					<SwiperSlide key={item.code}>
						<CategoryItem {...item} code={`/catalog/${item.code}`} />
					</SwiperSlide>
				))}

				{!!otherLinks &&
					Object.entries(otherLinks).map(([key, { code, imgSrc }]) => (
						<SwiperSlide key={key}>
							<CategoryItem
								imgSrc={imgSrc}
								code={code}
								link={code}
								title={key === `acs` ? `Аксессуары` : `Сравнение`}
							/>
						</SwiperSlide>
					))}
			</Swiper>
			<button className={clsx(cls.nav_button, cls.prev)} ref={navigationPrevRef}>
				<Icon name="ArrowLeft" />
			</button>
			<button className={clsx(cls.nav_button, cls.next)} ref={navigationNextRef}>
				<Icon name="ArrowRight" />
			</button>
		</section>
	)
}
